import React from 'react'
import './Found.css';
import { BsEmojiFrownFill } from "react-icons/bs";


const Found =()=> {
    return (
        <div className="not-found">
               404 Page Not Found <BsEmojiFrownFill/>
        </div>
    )
}

export default Found
